import React, { useState, useEffect } from "react";

const ListeaPases = ({ pases, onClick, paso }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  // Actualizar la hora actual cada minuto
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
//       console.log("fecha")
    }, 60000); // 1 minuto

    return () => clearInterval(interval); // Limpiar intervalo al desmontar
  }, []);

  function getHour(timestamp, paso) {
    const date = new Date(timestamp);
    
    // Formatear la hora
    const formattedHour = date.toLocaleTimeString("es-AR", { 
      hour: "2-digit", 
      minute: "2-digit", 
      day: "2-digit", 
      month: "2-digit", 
      year: "2-digit" 
    });

    let isRed = false;

    // Evaluar según el paso con la hora actual
    if (paso === 2) {
      isRed = date < currentTime; // Rojo si ya pasó la hora
    } else if (paso === 1) {
      isRed = date > currentTime; // Rojo si es una hora futura
    }

    // Retornar con estilo de color
    return (
      <span style={{ color: isRed ? "red" : "black" }}>
        {formattedHour}
      </span>
    );
  }

  return (
    <div style={{ textAlign: "center" }}>
      {pases && pases.length > 0 ? (
        <div style={{ width: "100%", overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", padding: "5px", fontSize: "12px" }}>N°</th>
                <th style={{ textAlign: "left", padding: "5px", fontSize: "12px" }}>Cadete</th>
                <th style={{ textAlign: "left", padding: "5px", fontSize: "12px" }}>Dni</th>
                <th style={{ textAlign: "left", padding: "5px", fontSize: "12px" }}>Promocion</th>
                <th style={{ textAlign: "left", padding: "5px", fontSize: "12px" }}>Compañia</th>
                <th style={{ textAlign: "left", padding: "5px", fontSize: "12px" }}>
                  {paso !== 2 ? "Horario Salida" : "Salio"}
                </th>
                <th style={{ textAlign: "left", padding: "5px", fontSize: "12px" }}>
                  Tipo
                </th>
                {paso === 2 && (
                  <th style={{ textAlign: "left", padding: "5px", fontSize: "12px" }}>Fecha Regreso</th>
                )}
              </tr>
            </thead>
            <tbody>
             {pases.map((item, index) => (
  <tr
    onClick={() => onClick(item)}
    key={item.dni}
    style={{
      color: "#333",
      backgroundColor: index % 2 === 0 ? "#f2f2f2" : "white",
      lineHeight: "1",
      fontSize: "12px",
    }}
  >
    <td style={{ padding: "5px", textAlign: "left" }}>{index + 1}</td>
    <td style={{ padding: "5px", textAlign: "left" }}>
      {item?.cadete?.cadeteApellido || "-"}
    </td>
    <td style={{ padding: "5px", textAlign: "left" }}>
      {item?.cadeteDni || "-"}
    </td>
    <td style={{ padding: "5px", textAlign: "left" }}>
      {item?.cadete?.Promocions?.[0]?.nombre || "-"}
    </td>
    <td style={{ padding: "5px", textAlign: "left" }}>
      {item?.cadete?.Seccion?.Compania?.nombre || "-"}
    </td>
    <td style={{ padding: "5px", textAlign: "left" }}>
      {item?.fechaHoraSalida ? getHour(item.fechaHoraSalida, 1) : "-"}
    </td>
    <td style={{ padding: "5px", textAlign: "left" }}>
      {item?.tipo || "-"}
    </td>
    {paso === 2 && (
      <td style={{ padding: "5px", textAlign: "left" }}>
        {item?.fechaHoraRegreso ? getHour(item.fechaHoraRegreso, 2) : "-"}
      </td>
    )}
  </tr>
))}

            </tbody>
          </table>
        </div>
      ) : (
        <p>Nada por ahora</p>
      )}
    </div>
  );
};

export default ListeaPases;
